import * as z from "zod";

export const cancelDownload = {
  name: "cancelDownload" as const,
  input: z.object({ downloadId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
